module.exports = __webpack_public_path__ + "img/visitManage.60a544a5.png";